import React, { memo } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { uuid } from '../../helpers/uuid';

const fairnessTextKeys = [
  'FAIRNESS_P1',
  'FAIRNESS_P2',
  'FAIRNESS_P3',
  'FAIRNESS_P4',
  'FAIRNESS_P5',
  'FAIRNESS_P6',
  'FAIRNESS_P7',
  'FAIRNESS_P8',
  'FAIRNESS_P9',
  'FAIRNESS_P10',
  'FAIRNESS_P11',
  'FAIRNESS_P12',
];
const AboutHashComp = ({ scrollRef }) => {
  const t = useTranslation();

  return (
    <div className="lotto-modal-par-holder" ref={scrollRef}>
      {
        fairnessTextKeys.map(item => <p key={uuid()} className="lotto-modal-par">{t(item)}</p>)
      }
    </div>
  );
};

AboutHashComp.displayName = 'AboutHash';
export const AboutHash = memo(AboutHashComp);
